import { memo, useContext, useEffect, type FunctionComponent } from 'react';
// local imports
import { DataContext } from '../context';
import SkillsGrid from '../v3/SkillsGrid';

type LearningProgressProps = {
  readonly supervisor?: boolean;
  readonly uid?: string | null;
  readonly duration?: number;
  // non-empty => a manager is editing this employee's skill levels
  readonly selectedEmployeeId?: string | null;
  // display name of that employee, shown in the skill level dialog
  readonly selectedEmployeeName?: string | null;
}

const LearningProgress: FunctionComponent<LearningProgressProps> = ({
  supervisor = false,
  uid,
  duration,
  selectedEmployeeId,
  selectedEmployeeName
}) => {
  const {
    learningProgress: { data: skills, pending, failed }, requireLearningProgress
  } = useContext(DataContext);

  useEffect(() => {
    requireLearningProgress?.({ duration });
  }, [uid, requireLearningProgress, duration]);

  return (
    <SkillsGrid
        source="learning"
        selectedEmployeeId={selectedEmployeeId}
        selectedEmployeeName={selectedEmployeeName}
        isEmployee={!supervisor}
        readOnly={supervisor}
        supervisor={supervisor}
        notFoundMessage="skills.no_learning_progress"
        withCourses
        skills={skills}
        pending={pending}
        failed={failed}
    />
  );
};

export default memo(LearningProgress);
